import React from 'react';
import { deluxeProps } from '../../Templates/Assessment/Assessment';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/maas360-estimator/locales/messages';

type deluxDataProps = {
  data: deluxeProps;
  noAdditionalReq: boolean;
};

const Deluxe = ({ data, noAdditionalReq }: deluxDataProps) => {
  return noAdditionalReq ? (
    <div className="deluxe-margin">
      <div className="page_sub_heading_2">
        <FormattedMessage {...messages.other_results_heading} />: {data.title}
      </div>
      <div className="margin-top">
        <span className="page_body">{data.shortDesc}</span>
      </div>
    </div>
  ) : (
    <div className="deluxe-margin">
      <div className="page_sub_heading_2">
        <FormattedMessage {...messages.other_results_heading} />: {data.title}
      </div>
      <div className="margin-top">
        <span className="page_body">{data.shortDesc}</span>
      </div>
    </div>
  );
};

export default Deluxe;
